import { useMemo } from 'react'
import { useInIframe } from '@/services/useInIframe'
import { useTranslation } from 'react-i18next'
import { Button } from '@/UIComponents2/Button'

type LaunchAppButtonProps = {
    joinCode: string | undefined
    joinLinkMetadata: { [key: string]: string } | undefined
}
export function LaunchAppButton(props: LaunchAppButtonProps) {
    const { t } = useTranslation()
    const inIframe = useInIframe()

    const appOpenUrl = useMemo(() => {
        const q = new URLSearchParams()
        q.set('code', props.joinCode ?? '')
        for (const param in props.joinLinkMetadata) {
            q.set(`m_${param}`, props.joinLinkMetadata[param])
        }
        return `museapp://join-room?${q.toString()}`
    }, [props.joinCode, props.joinLinkMetadata])

    if (inIframe) {
        return null
    }
    return (
        <Button
            className="w-full text-muse-yellow hidden md:flex"
            variant="secondary"
            onClick={(e) => {
                e.preventDefault()
                window.location.href = appOpenUrl
            }}
        >
            {t('Launch Muse desktop app')}
        </Button>
    )
}
